<template>
  <div class="operations-timing-push-dialog">
    <custom-dialog
      width="600px"
      :title="model.title"
      :visible="visible"
      v-on="$listeners"
      @close="closeDialog"
      :append-to-body="true"
    >
      <div class="dialog-body">
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          label-position="top"
        >
          <el-form-item :label="$t('Common.com_email')" prop="email" required>
            <el-input
              v-model.trim="form.email"
              :placeholder="$t('schedules_timing_push_dialog.srdgyxqygkzdsr5gyx')"
            ></el-input>
          </el-form-item>

          <el-form-item :label="$t('Common.com_status')" prop="state">
            <el-radio-group v-model="form.state">
              <el-radio
                v-for="item in cloudCommonStateList"
                :key="item.value"
                :label="Number(item.value)"
              >{{ item.name }}</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item :label="$t('schedules_timing_push_dialog.bao_biao_lei_xing')" prop="reportType">
            <custom-select
              v-model="form.reportType"
              code="report_export_type"
              :dataFilter="reportTypeFilter"
              style="width: 100%"
            ></custom-select>
          </el-form-item>

          <el-form-item v-if="showReportPeriod && String(form.reportType) === '1'" :label="$t('schedules_timing_push_dialog.bbsjd')" class="time-range-item">
            <template v-if="String(form.reportType) === '1'">
              <div class="time-range-option">
                <el-radio v-model="form.periodType" :label="1">{{ $t('schedules_timing_push_dialog.an_zi_ran_yue') }}</el-radio>
              </div>
              <div class="time-range-option time-range-row">
                <el-radio v-model="form.periodType" :label="2">{{ $t('schedules_timing_push_dialog.zi_ding_yi_tian_shu') }}</el-radio>
                <span class="range-value">{{ form.customDays }}{{ $t('schedules_timing_push_dialog.tian') }}</span>
              </div>
              <div class="time-range-slider">
                <el-slider
                  v-model="form.customDays"
                  :min="12"
                  :max="daysInMonth"
                  :disabled="form.periodType === 1"
                  :show-tooltip="false"
                ></el-slider>
                <div class="slider-scale">
                  <span>{{ $t('schedules_timing_push_dialog.12tian') }}</span>
                  <span>{{ daysInMonth }}{{ $t('schedules_timing_push_dialog.tian') }}</span>
                </div>
              </div>
            </template>
          </el-form-item>

          <el-form-item prop="pushTime" required>
            <div style="display: flex; align-items: center; justify-content: space-between; width: 100%; line-height: 24px; padding-bottom: 4px;">
              <span><span style="color: #f56c6c; margin-right: 4px;">*</span>{{ $t('schedules_timing_push_dialog.tsyjrqsj') }}</span>
              <span>{{ pushTimeHint }}</span>
            </div>
            <template v-if="isDatePushReport">
              <div class="push-time-row" style="display: flex; flex-wrap: nowrap; align-items: flex-start; width: 100%; margin-bottom: 10px;">
                <div class="push-date-input" style="flex: 1 1 auto; width: 0; min-width: 0;">
                  <el-input :value="pushDaysString" readonly :placeholder="$t('schedules_timing_push_dialog.qxztsrq')">
                    <i slot="suffix" class="el-input__icon el-icon-arrow-down"></i>
                  </el-input>
                </div>
                <el-time-select
                  v-model="form.pushTime"
                  @change="validatePushTimeField"
                  :picker-options="{ start: '00:00', step: '00:30', end: '23:30' }"
                  :placeholder="$t('schedules_timing_push_dialog.xuan_ze_shi_jian')"
                  class="push-time-select"
                  style="flex: 0 0 120px; width: 120px; margin-left: 10px;"
                ></el-time-select>
              </div>
              <div class="calendar-grid timing-push-calendar-grid">
                <div
                  v-for="day in daysInMonth"
                  :key="day"
                  class="calendar-cell"
                  :class="{ active: form.pushDays.some(d => String(d) === String(day)) }"
                  @click="togglePushDay(day)"
                >
                  {{ day }}
                </div>
                <div class="calendar-cell empty" v-for="i in emptyDayCells" :key="'empty' + i"></div>
              </div>
            </template>

            <template v-if="String(form.reportType) === '2'">
              <div class="push-time-row week-time-row" style="display: flex; flex-wrap: nowrap; align-items: flex-start; width: 100%;">
                <custom-select
                  v-model="form.pushWeeks"
                  code="week_type"
                  multiple
                  :placeholder="$t('schedules_timing_push_dialog.qxztsrq')"
                  width="100%"
                  class="push-date-input"
                  style="flex: 1 1 auto; width: 0; min-width: 0;"
                  @change="validatePushTimeField"
                ></custom-select>
                <el-time-select
                  v-model="form.pushTime"
                  @change="validatePushTimeField"
                  :picker-options="{ start: '00:00', step: '00:30', end: '23:30' }"
                  :placeholder="$t('schedules_timing_push_dialog.xuan_ze_shi_jian')"
                  class="push-time-select"
                  style="flex: 0 0 120px; width: 120px; margin-left: 10px;"
                ></el-time-select>
              </div>
            </template>
          </el-form-item>

        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" plain @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
        <el-button type="warning" :loading="submitting" :disabled="submitting" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import moment from 'moment';
import dialogMixins from '@/mixins/dialog_mixins.js';
import apis from '@/utils/apis';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      submitting: false,
      showReportPeriod: false,
      cloudCommonStateList: [],
      form: {
        orgType: 'CS',
        orgId: '',
        orgName: '',
        userId: '',
        userName: '',
        realname: '',
        email: '',
        state: 1,
        reportType: '1',
        periodType: 2,
        customDays: 14,
        customWeeks: 12,
        pushDays: [],
        pushWeeks: [],
        pushTime: '07:30',
      },
    };
  },
  computed: {
    rules() {
      return {
        email: [
          { required: true, message: this.$t('schedules_timing_push_dialog.qsryx'), trigger: 'blur' },
          { validator: this.validateEmail, trigger: 'blur' },
        ],
        pushTime: [
          { required: true, validator: this.validatePushTime, trigger: 'change' },
        ],
      };
    },
    daysInMonth() {
      return moment().daysInMonth();
    },
    pushDaysString() {
      if (!this.form.pushDays || this.form.pushDays.length === 0) {
        return '';
      }
      const days = [...this.form.pushDays].sort((a, b) => a - b);
      return this.$t('schedules_timing_push_dialog.mei_yueori', [days.join('、')]);
    },
    emptyDayCells() {
      const cols = 10;
      const remainder = this.daysInMonth % cols;
      return remainder === 0 ? 0 : cols - remainder;
    },
    isDatePushReport() {
      return ['1', '3'].includes(String(this.form.reportType));
    },
    // 根据报表类型展示对应的数据范围提示。
    pushTimeHint() {
      const reportPeriodTextMap = {
        1: this.$t('schedules_timing_push_dialog.sxrqqssrsj'),
        2: this.$t('schedules_timing_push_dialog.sxrqqsezsj'),
        3: this.$t('schedules_timing_push_dialog.sxrqqsegysj'),
      };
      return reportPeriodTextMap[String(this.form.reportType)] || '';
    },
  },
  mounted() {
    this.getCloudCommonState();
    this.init();
  },
  watch: {
    'form.reportType'(val) {
      const reportType = String(val);
      if (reportType === '1') {
        this.form.customDays = 14;
      } else {
        this.form.periodType = 2;
      }
      if (reportType === '2') {
        this.form.customWeeks = 12;
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate('pushTime');
        }
      });
    },
  },
  methods: {
    validatePushTime(rule, value, callback) {
      if (this.isDatePushReport) {
        if (!this.form.pushDays || this.form.pushDays.length === 0) {
          callback(new Error(this.$t('schedules_timing_push_dialog.qzsxzyttsyj')));
          return;
        }
      } else if (!this.form.pushWeeks || this.form.pushWeeks.length === 0) {
        callback(new Error(this.$t('schedules_timing_push_dialog.qzsxzyttsyj')));
        return;
      }

      if (!this.form.pushTime) {
        callback(new Error(this.$t('schedules_timing_push_dialog.qxztssj')));
        return;
      }
      callback();
    },
    validatePushTimeField() {
      if (this.$refs.form) {
        this.$refs.form.validateField('pushTime');
      }
    },
    init() {
      this.setCurrentUserInfo();
      if (this.model && this.model.data) {
        const data = this.model.data;
        this.form.email = data.email || data.pushEmail || '';

        if (data.state !== undefined) {
          this.form.state = Number(data.state);
        } else if (data.state !== undefined) {
          this.form.state = Number(data.state);
        }
        if (data.reportType !== undefined && data.reportType !== null && data.reportType !== '') {
          this.form.reportType = String(data.reportType);
        } else if (data.pushMethod !== undefined && data.pushMethod !== null && data.pushMethod !== '') {
          this.form.reportType = String(data.pushMethod) === '3' ? '1' : String(data.pushMethod);
        }
        if (data.periodType !== undefined && data.periodType !== null && data.periodType !== '') {
          this.form.periodType = Number(data.periodType);
        }

        if (data.periodValue !== undefined && data.periodValue !== null && data.periodValue !== '') {
          if (this.form.periodType === 2) {
            if (String(this.form.reportType) === '1') {
              this.form.customDays = Number(data.periodValue);
            } else if (String(this.form.reportType) === '2') {
              this.form.customWeeks = 12;
            }
          }
        } else {
          if (data.customDays !== undefined && data.customDays !== null && data.customDays !== '') {
            this.form.customDays = Number(data.customDays);
          }
          if (data.customWeeks !== undefined && data.customWeeks !== null && data.customWeeks !== '') {
            this.form.customWeeks = 12;
          }
        }
        if (String(this.form.reportType) === '1') {
          this.form.customDays = 14;
        }
        if (String(this.form.reportType) === '2') {
          this.form.customWeeks = 12;
        }

        const pushConditionList = String(data.pushCondition || '')
          .split(',')
          .map(item => Number(item))
          .filter(item => !Number.isNaN(item));
        if (pushConditionList.length) {
          if (this.isDatePushReport) {
            this.form.pushDays = pushConditionList;
          } else {
            this.form.pushWeeks = pushConditionList;
          }
        }

        if (data.pushDays) {
          this.form.pushDays = data.pushDays;
        }
        if (data.pushWeeks) {
          this.form.pushWeeks = data.pushWeeks;
        }
        if (data.pushTime) {
          this.form.pushTime = this.normalizePushTimeForDisplay(data.pushTime);
        }
      }
    },
    setCurrentUserInfo() {
      const userInfo = this.userInfo || {};
      this.form.orgType = userInfo.bizType || this.form.orgType;
      this.form.orgId = userInfo.rootOrgId || this.form.orgId;
      this.form.orgName = userInfo.rootOrgName || this.form.orgName;
      this.form.userId = userInfo.userId || this.form.userId;
      this.form.userName = userInfo.userName || userInfo.loginName || this.form.userName;
      this.form.realname = userInfo.realName || userInfo.realname || this.form.realname;
    },
    closeDialog() {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
    getCloudCommonState() {
      this.getDictionary('cloud_common_state', (dictionary) => {
        const list = (dictionary && dictionary.cloud_common_state) || [];
        this.cloudCommonStateList = list;
      });
    },
    reportTypeFilter(list) {
      if (!Array.isArray(list)) {
        return [];
      }
      return list.filter(item => ['1', '2', '3'].includes(String(item && item.value)));
    },
    validateEmail(rule, value, callback) {
      const emailList = (value || '')
        .split(';')
        .map(item => item.trim())
        .filter(item => item);
      const emailReg = /^\w+([-.+]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      if (!emailList.length) {
        callback(new Error(this.$t('schedules_timing_push_dialog.qsryx')));
        return;
      }
      if (emailList.length > 5) {
        callback(new Error(this.$t('schedules_timing_push_dialog.zdsr5gyx')));
        return;
      }
      const invalidEmail = emailList.find(item => !emailReg.test(item));
      if (invalidEmail) {
        callback(new Error(this.$t('schedules_timing_push_dialog.qsrzqdyx')));
        return;
      }
      callback();
    },
    normalizePushTimeForDisplay(time) {
      const t = String(time || '').trim();
      if (!t) {
        return '';
      }
      if (t.includes(':')) {
        return t;
      }
      if (t.length === 4) {
        return `${t.slice(0, 2)}:${t.slice(2, 4)}`;
      }
      return t;
    },
    normalizePushTimeForStorage(time) {
      const t = String(time || '').trim();
      if (!t) {
        return '';
      }
      const normalized = t.includes(':') ? t.replace(':', '') : t;
      return normalized.padStart(4, '0');
    },
    togglePushDay(day) {
      const strDay = String(day);
      const index = this.form.pushDays.findIndex(d => String(d) === strDay);
      if (index > -1) {
        this.form.pushDays.splice(index, 1);
      } else {
        this.form.pushDays.push(day);
      }
      this.$refs.form.validateField('pushTime');
    },
    toCommaString(value) {
      if (Array.isArray(value)) {
        return [...value].sort((a, b) => Number(a) - Number(b)).join(',');
      }
      if (value === undefined || value === null) {
        return '';
      }
      return String(value);
    },
    getSubmitData() {
      this.setCurrentUserInfo();
      const emailList = this.form.email
        .split(';')
        .map(item => item.trim())
        .filter(item => item);
      const emailListStr = emailList.join(',');

      const reportType = String(this.form.reportType);
      const isDayReport = reportType === '1';
      const isWeekReport = reportType === '2';
      // 日报按天、周报按周、月报按月使用对应的默认周期。
      const reportPeriodMap = {
        1: 14,
        2: 12,
        3: 12,
      };
      const reportPeriod = reportPeriodMap[reportType];
      const pushCondition = this.isDatePushReport ? this.form.pushDays : this.form.pushWeeks;
      const pushMethod = this.isDatePushReport ? 3 : 2;
      const periodType = isDayReport && this.form.periodType === 1 ? 1 : 2;
      const submitData = {
        genScheduleId: this.model && this.model.type === 'edit' ? (this.model.data && this.model.data.genScheduleId) : undefined,
        orgType: this.form.orgType,
        orgId: this.form.orgId,
        orgName: this.form.orgName,
        userId: this.form.userId,
        userName: this.form.userName,
        realname: this.form.realname,
        pushEmail: this.form.email,
        emailList: emailListStr,
        state: this.form.state,
        pushMethod,
        reportType,
        periodValue: reportPeriod,
        periodType,
        customDays: isDayReport ? reportPeriod : undefined,
        customWeeks: isWeekReport ? reportPeriod : undefined,
        pushCondition: this.toCommaString(pushCondition),
        pushTime: this.normalizePushTimeForStorage(this.form.pushTime),
      };

      if (isDayReport && this.form.periodType === 1) {
        delete submitData.periodValue;
      }

      return submitData;
    },
    confirm() {
      // 提交过程中禁止重复触发，避免保存多条相同计划
      if (this.submitting) {
        return;
      }
      this.submitting = true;
      this.$refs.form.validate((valid) => {
        if (!valid) {
          this.submitting = false;
          return;
        }
        this.$postJSON(apis.workReportScheduleSave, this.getSubmitData(), true).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.$emit('success');
          this.closeDialog();
        }).finally(() => {
          this.submitting = false;
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.operations-timing-push-dialog {
  .push-time-row {
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 10px;
  }

  .week-time-row {
    align-items: flex-start;
    margin-bottom: 0;
  }

  .push-date-input {
    flex: 1 1 auto;
    width: 0;
    min-width: 0;
  }

  .push-date-input ::v-deep .el-input,
  .push-date-input ::v-deep .el-select {
    width: 100%;
  }

  .push-time-select {
    flex: 0 0 120px;
    width: 120px !important;
  }

  .el-icon-arrow-down {
    cursor: pointer;
  }

}
</style>

<style lang="scss">
.time-range-item {
  .time-range-option {
    min-height: 32px;
    line-height: 32px;
  }

  .time-range-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-top: 8px;
  }

  .time-range-slider {
    padding: 0 6px 0 14px;
    margin-top: 4px;

    .el-slider__runway {
      margin: 12px 0 14px;
    }
  }

  .slider-scale {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top: -4px;
    color: #999999;
    font-size: 12px;
    line-height: 18px;
  }

  .range-value {
    flex: 0 0 60px;
    text-align: right;
    color: #333;
    font-weight: 500;
  }
}

.timing-push-calendar-grid {
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  margin-top: 10px;
  background-color: #fff;
  border-top: 1px solid #e4e7ed;
  border-left: 1px solid #e4e7ed;

  .calendar-cell {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 36px;
    border-right: 1px solid #e4e7ed;
    border-bottom: 1px solid #e4e7ed;
    cursor: pointer !important;
    font-size: 13px;
    color: #606266;
    transition: background-color 0.15s, color 0.15s;
    user-select: none;

    &:hover:not(.empty):not(.active) {
      color: #00a4ff !important;
      background-color: #f0f9ff !important;
    }

    &.active {
      background-color: #00a4ff !important;
      color: #fff !important;
    }

    &.empty {
      cursor: default !important;
      pointer-events: none;
    }
  }
}
</style>
